<template>
  <div v-if="showModal">
    <a-modal
      class="drag-tip-modal-class"
      v-model:visible="showModal"
      :closable="false"
      :centered="true"
      :maskClosable="false"
      :width="500"
      :footer="null"
      wrapClassName="drag-tip-modal"
    >
      <div class="title">移动到文件夹</div>
      <div class="content">{{ dragTipsContent.label }}</div>
      <div class="btn" @click="toggleModal">我知道了</div>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import './index.scss';
import localStorage from '@/utils/localStorage';
import storeController from '@/controller/store';
import { DragTips } from '../Folder/drop';

const props = defineProps({
  dragTipsContent: {
    type: Object,
    default: () => {},
  },
});
const emit = defineEmits(['setShowDragTipModal']);

const { getData } = storeController();
const localStorageKey = `${getData('userInfo').userId}-drag-tips`;
const sameNameTips = props.dragTipsContent.value === DragTips.sameNameTips.value;
const showModal = ref(sameNameTips ? !localStorage.get(localStorageKey) : true);

function toggleModal() {
  showModal.value = false;
  emit('setShowDragTipModal', false);
  // 只有同名文件的提示才使用localStorage提示一次，其余的每次提示
  if (sameNameTips) {
    localStorage.set(localStorageKey, true);
  }
}
</script>
